import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import {
  infoFecthCajaCurricularI,
  makeCajaCurricular,
} from "dtos/cajaCurricular";

export const getCajaCurricular = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFecthCajaCurricularI>
  >({
    method: "GET",
    uri: ENDPOINTS.CAJAS_CURRICULARES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeCajaCurricular(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postCajaCurricular = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCajaCurricularI>({
    method: "POST",
    uri: ENDPOINTS.CAJAS_CURRICULARES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCajaCurricular(response);
};

export const putCajaCurricular = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCajaCurricularI>({
    method: "PUT",
    uri: ENDPOINTS.CAJAS_CURRICULARES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCajaCurricular(response);
};

export const deleteCajaCurricular = async (id: any) => {
  const response = await sendRequest<infoFecthCajaCurricularI>({
    method: "DELETE",
    uri: ENDPOINTS.CAJAS_CURRICULARES + "/" + id,
  });
  return makeCajaCurricular(response);
};

export const getCajaCurricularById = async (id: any, params?: any) => {
  const response = await sendRequest<infoFecthCajaCurricularI | undefined>({
    method: "GET",
    uri: ENDPOINTS.CAJAS_CURRICULARES + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makeCajaCurricular(response) : undefined;
};

export const getCajasCurricularesByPlanEstudio = async (planEstudioId: number) => {
  const response = await sendRequest<getResponseWithPagination<infoFecthCajaCurricularI>>({
    method: "GET",
    uri: ENDPOINTS.CAJAS_CURRICULARES + "/byPlanEstudio/" + planEstudioId,
  });
  console.log("re3sponse ",response);
  
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeCajaCurricular(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};
